import type { Application } from 'src/types/application'

import api from 'src/constants/api'

import useQuery from 'src/hooks/utils/useQuery'

const useApplicationsQuery = (serviceNowId: string) => {
  return useQuery(
    ['applications', serviceNowId],
    async ({ signal }) => {
      const response = await api.get(`/graph/account/${serviceNowId}/applications`, { signal })
      return response.data.value as Application[]
    },
    {
      errorMessage: 'Failed to fetch applications',
      cacheTime: 60 * 1000 * 5,
      refetchOnWindowFocus: false,
      enabled: !!serviceNowId
    }
  )
}

export default useApplicationsQuery
